<template>
  <available-components-for-theme8 :specific-components="components" />
</template>
<script lang="ts">
import AvailableComponentsForTheme8 from '~/components/theme8/AvailableComponentsForTheme8.vue';
import { ViewsMixin } from '~/mixins/views.mixin';

export default defineNuxtComponent({
  name: 'Theme8View',

  mixins: [ViewsMixin],

  components: {
    AvailableComponentsForTheme8,
  },

  description:
    'Components that can be used through this theme should be imported here in order to use them dynamically',
});
</script>
